import { format } from 'date-fns';
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/ExportServices`;

export const getIQSurveyReportsZip = async ({ startDate = null, endDate = null } = {}) => {
  const requestUrl = `${baseRoute}/IQSurvey/Zip?startDate=${!!startDate ? startDate.toJSON() : ''}&endDate=${
    !!endDate ? endDate.toJSON() : ''
  }`;

  let headers = getHeaders();
  const response = await fetch(requestUrl, {
    method: 'GET',
    headers,
  });

  if (response.status === 204) {
    throw new Error(
      'There is no data available for the selected date range. Please select a different date range to generate the report.',
    );
  }

  if (!response.ok) {
    throw new Error('IQ Survey Results export failed');
  }

  const blob = await response.blob();
  downloadData(blob, `IQSurvey_Reports.zip`);

  return true;
};

const selfInspectOutcomeQuery = ({ startDate, endDate, clientId }) =>
  `startDate=${format(startDate, 'yyyy-MM-dd')}&endDate=${format(endDate, 'yyyy-MM-dd')}${
    !!clientId ? `&clientId=${clientId}` : ''
  }`;

export const getSelfInspectOutcomeData = async ({ startDate, endDate, clientId = null }) => {
  const requestUrl = `${baseRoute}/SelfInspectOutcomes/Data?${selfInspectOutcomeQuery({
    startDate,
    endDate,
    clientId,
  })}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (response.status === 204) {
    return null;
  }

  if (!response.ok) {
    throw new Error('Self Inspect Outcomes report failed');
  }

  return response.json();
};

export const getSelfInspectOutcomeExcel = async ({ startDate, endDate, clientId = null }) => {
  const requestUrl = `${baseRoute}/SelfInspectOutcomes?${selfInspectOutcomeQuery({ startDate, endDate, clientId })}`;

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (response.status === 204) {
    throw new Error('There is no data available for the selected filters.');
  }

  if (!response.ok) {
    throw new Error('Self Inspect Outcomes export failed');
  }

  const blob = await response.blob();
  downloadData(blob, `SelfInspectOutcomes_${format(startDate, 'yyyyMMdd')}_${format(endDate, 'yyyyMMdd')}.xlsx`);

  return true;
};

// PRIVATE
const downloadData = (data, filename) => {
  var textUrl = URL.createObjectURL(data);
  var element = document.createElement('a');
  element.setAttribute('href', textUrl);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
